module.exports = __webpack_public_path__ + "static/img/Frederic-Abbal_2017-18.061d64a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Frederic-Abbal_2017-18.jpg
// module id = PDq3
// module chunks = 0